// Si la dejás vacía [], no se reemplaza nada
export const FORBIDDEN_CHARS: string[] = ['|']; // podés sumar: ['|', '?', '(', ')', ':', ';']